var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.color == 'orange' ? 'orange-button' : 'purple-button']},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }